import { useGetIntegrationWebhooksEvents } from 'api';

import { useOrganisationId } from 'hooks/context';

export const useWebhookEvents = () => {
  const organisationId = useOrganisationId<number>();
  const { data, isLoading, isError } =
    useGetIntegrationWebhooksEvents(organisationId);

  return { events: data?.data ?? [], isLoading, isError };
};
